import { render, staticRenderFns } from "./SelectUpdateTags.vue?vue&type=template&id=4ac250b2&"
import script from "./SelectUpdateTags.vue?vue&type=script&lang=ts&"
export * from "./SelectUpdateTags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports